import api from '@/lib/axios';

export interface InvitationDetails {
  id: string;
  email: string;
  first_name?: string;
  workspace: {
    id: string;
    name: string;
    slug: string;
  };
  role: string;
  status: 'pending' | 'accepted' | 'declined' | 'expired';
  expires_at?: string;
  invited_by?: {
    id: string;
    email: string;
    first_name?: string;
    last_name?: string;
  };
}

export interface ValidateInvitationResponse {
  valid: boolean;
  invitation?: InvitationDetails;
  reason?: string;
}

export interface AcceptInvitationRequest {
  password: string;
  terms_accepted: boolean;
}

export interface AcceptInvitationResponse {
  token: string;
  user: {
    id: string;
    email: string;
    first_name?: string;
    last_name?: string;
  };
  workspace: {
    id: string;
    slug: string;
    name: string;
  };
}

/**
 * Fetch invitation details by token
 */
export async function fetchInvitationDetails(token: string): Promise<InvitationDetails> {
  const response = await api.get<InvitationDetails>(`/invitations/${token}`);
  return response.data;
}

/**
 * Validate invitation token
 */
export async function validateInvitation(token: string): Promise<ValidateInvitationResponse> {
  const response = await api.get<ValidateInvitationResponse>(`/invitations/validate`, {
    params: { token },
  });
  return response.data;
}

/**
 * Accept an invitation by token
 */
export async function acceptInvitation(
  token: string,
  data: AcceptInvitationRequest
): Promise<AcceptInvitationResponse> {
  const response = await api.post<AcceptInvitationResponse>(`/invitations/accept`, {
    token,
    ...data,
  });
  return response.data;
}
